module.exports = "/_next/static/images/qr-3f238f24edc131dd1ee471bb21da404f.svg";